/*
 * @Description: priceCompareJob
 * @Author: jiyangyang
 * @Date: 2022-09-06 15:29:46
 */

import axiosConfig from '@/sso/axios-config'
import { filterParameters } from '@/util/common'

export async function detail(id) {
  const data = {
    id,
  }

  return await axiosConfig.service({
    url: '/priceCompareJob/detail',
    method: 'post',
    data: data,
  })
}

export async function add(formData) {
  return await axiosConfig.service({
    url: '/priceCompareJob/add',
    method: 'post',
    data: formData,
  })
}

export async function deleteFile(formData) {
  return await axiosConfig.service({
    url: '/priceCompareJob/deleteFile',
    method: 'post',
    data: formData,
  })
}

export async function queryList(condition, currPage, pageSize) {
  const copy = filterParameters(condition)
  const data = {
    currPage,
    pageSize,
    condition: copy,
  }
  return await axiosConfig.service({
    url: '/priceCompareJob/list',
    method: 'post',
    data: data,
  })
}
